module.exports = __webpack_public_path__ + "static/img/WS-9001.1718793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/WS-9001.png
// module id = MgjP
// module chunks = 4